import { render, staticRenderFns } from "./WarrantyClain.vue?vue&type=template&id=0ac5dc28&"
import script from "./WarrantyClain.vue?vue&type=script&lang=js&"
export * from "./WarrantyClain.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyClain.vue?vue&type=style&index=0&id=0ac5dc28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports